import { createSlice } from "@reduxjs/toolkit";

const tourOrderSlice = createSlice({
  name: "tourOrder",
  initialState: {
    loading: false,
    error: false,
    tourOrder: [],
    tourOrderAdmin: [],
    statistical: [],
    totalPage: 0,
    totalItem: 0
  },
  reducers: {
    createTour: (state) => {
      state.loading = true;
      state.error = false;
    },
    createTourSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    createTourFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    getTour: (state) => {
      state.loading = true;
      state.error = false;
    },
    getTourSuccess: (state, action) => {
      state.loading = false;
      state.tourOrder = action.payload.data
      state.error = false;
    },
    getTourFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    getStatistical: (state) => {
      state.loading = true;
      state.error = false;
    },
    getStatisticalSuccess: (state, action) => {
      state.loading = false;
      state.statistical = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getStatisticalFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateTour: (state) => {
      state.loading = true;
      state.error = false;
    },
    updateTourSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    updateTourFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateTourAdmin: (state) => {
      state.loading = true;
      state.error = false;
    },
    updateTourAdminSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    updateTourAdminFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    removeTour: (state) => {
      state.loading = true;
      state.error = false;
    },
    removeTourSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
    },
    removeTourFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    getTourAdmin: (state) => {
      state.loading = true;
      state.error = false;
    },
    getTourAdminSuccess: (state, action) => {
      state.loading = false;
      state.tourOrderAdmin = action.payload.data
      state.totalPage = action.payload.totalPage
      state.totalItem = action.payload.totalItem
      state.error = false;
    },
    getTourAdminFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const tourOrderActions = tourOrderSlice.actions;
export default tourOrderSlice.reducer;
